import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'
import { GradientContainer } from '../components'

const HomeInfo: React.FC = () => {
  const navigate = useNavigate()

  const handleViewWork = () => {
    navigate('/portfolio')
  }

  const handleContact = () => {
    navigate('/contact')
  }

  return (
    <div className='text-white p-4 md:p-8 h-full w-full'>
      <div className='w-full h-full flex flex-col justify-between'>
        {/* Header Section */}
        <div className='text-right pt-safe-top'>
          <div className='text-lg md:text-xl w-full'>
            /mar.ha.ba/
            <br />
            <span className='text-3xl md:text-5xl font-stretchRegular'>Heello, مرحبا</span>
          </div>
        </div>
        {/* Buttons Section - Always at bottom */}
        <div className='text-white text-sm md:text-l text-right w-full font-stretchRegular mt-auto flex flex-col md:flex-row justify-end gap-4 md:gap-8 pb-safe-bottom'>
          {/* VIEW MY WORK Button */}
          <button 
            onClick={handleViewWork}
            className='group relative border-2 border-white/30 rounded-3xl p-4 md:p-5 overflow-hidden backdrop-blur-sm transition-all duration-300 ease-out hover:border-white/60 hover:bg-white/10 hover:scale-105 hover:shadow-lg w-full md:w-auto'
          >
            <div className='flex items-center justify-center md:justify-start gap-2 relative z-10'>
              <span className='transition-transform duration-300 group-hover:-translate-x-1 text-center md:text-left whitespace-nowrap'>
                VIEW MY WORK
              </span>
              <ArrowUpRight 
                size={18} 
                className='transition-all duration-300 ease-out transform translate-x-8 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 group-hover:rotate-12 flex-shrink-0' 
              />
            </div>
            {/* Sliding background effect */}
            <div className='absolute inset-0 bg-gradient-to-r from-white/5 to-white/10 transform -translate-x-full transition-transform duration-300 ease-out group-hover:translate-x-0'></div>
          </button>
          {/* CONTACT ME Button */}
          <button 
            onClick={handleContact}
            className='group relative border-2 border-white/30 rounded-3xl p-4 md:p-5 overflow-hidden backdrop-blur-sm transition-all duration-300 ease-out hover:border-white/60 hover:bg-white/10 hover:scale-105 hover:shadow-lg w-full md:w-auto'
          >
            <div className='flex items-center justify-center md:justify-start gap-2 relative z-10'>
              <span className='transition-transform duration-300 group-hover:-translate-x-1 text-center md:text-left whitespace-nowrap'>
                CONTACT ME
              </span>
              <ArrowUpRight 
                size={18} 
                className='transition-all duration-300 ease-out transform translate-x-8 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 group-hover:rotate-12 flex-shrink-0' 
              />
            </div>
            {/* Sliding background effect */}
            <div className='absolute inset-0 bg-gradient-to-r from-white/5 to-white/10 transform -translate-x-full transition-transform duration-300 ease-out group-hover:translate-x-0'></div>
          </button>
        </div>
      </div>
    </div>
  )
}

const Home = () => {
  return (
    <div className='bg-black p-4 md:p-8 flex flex-col'
         style={{
           height: '100dvh', // Dynamic viewport height - adjusts for iOS Safari address bar
           minHeight: '100svh' // Small viewport height - ensures minimum height when address bar is visible
         }}>
      <div className='flex-1'>
        <GradientContainer components={[<HomeInfo key="home-information"/>]}/>
      </div>
      <div className='absolute text-white opacity-30 text-xs'
           style={{
             bottom: 'max(0.5rem, env(safe-area-inset-bottom))',
             left: 'max(0.5rem, env(safe-area-inset-left))'
           }}>
        &copy; AHMED ELGHAMRINY
      </div>
    </div>
  )
}

export default Home;